import { useState, useEffect } from "react";

// Breakpoint for mobile devices (in pixels)
const MOBILE_BREAKPOINT = 600;

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(
    window.innerWidth <= MOBILE_BREAKPOINT
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
    };

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Clean up
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile;
}

// For backward compatibility with class components
export function isMobile() {
  return window.innerWidth <= MOBILE_BREAKPOINT;
}
